module.exports = __webpack_public_path__ + "img/2_B.6d673ffa.png";